import Helmet from "react-helmet/lib/Helmet";
import React from "react";
import {useState,useEffect} from "react";
import Link from "react-router-dom/Link";
import axios from 'axios';
import LayoutWithLinksToRoot from "../components/LayoutWithLinkBackToHome";

function Notfound() {
  const [information, setInformation] = useState("");
  
  useEffect(() => {
    axios.get("/api/information").then((response) => {
      setInformation(response.data);
    });
  }, []);
  
  return (
    <LayoutWithLinksToRoot id="not-found">
      <Helmet>
        <title>404 - Not found - Daniel Moka</title>
        <meta
          name="description"
          content={information.metaDescription}
        />
      </Helmet>
      <div className="mi-about-area mi-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="notfound">
                <div className="notfound-inner text-center">
                  <h1>404</h1>
                  <h3>Whoops!!! Page not found!</h3>
                  <Link to="/" className="mi-button">
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutWithLinksToRoot>
  );
}

export default Notfound;
